import React, { forwardRef } from "react";
import { Box, TextField, Typography } from "@mui/material";
import Swal from "sweetalert2";

const FormatTimestamp = forwardRef(
  ({ handleChange, value, stateProp, indexToChange, dense = false, onSecondsTab }, ref) => {
    const handleSecondsKeyDown = e => {
      if (e.key === "Tab" && !e.shiftKey) {
        e.preventDefault(); // Prevent default TAB behavior
        // Call the callback to move to tapping point field
        if (onSecondsTab) {
          onSecondsTab(indexToChange);
        }
      }
    };

    const handleMinutesChange = e => {
      const minutes = parseInt(e.target.value) || 0;
      if (minutes > 60) {
        Swal.fire({
          icon: "error",
          text: "Minutes cannot be greater than 60",
        });
        return;
      }
      let valSeconds = value % 60;
      let newValue = minutes * 60 + valSeconds;
      handleChange(newValue, stateProp, indexToChange, "timestamp");
    };

    const handleSecondsChange = e => {
      const seconds = parseInt(e.target.value) || 0;
      if (seconds > 59) {
        Swal.fire({
          icon: "error",
          text: "Seconds cannot be greater than 59",
        });
        return;
      }
      let valMinutes = value - (value % 60);
      let newValue = seconds + valMinutes;
      handleChange(newValue, stateProp, indexToChange, "timestamp");
    };

    const inputWidth = dense ? "56px" : "65px";
    const containerGap = dense ? 0.5 : 1;
    const inputPadding = dense ? "6px" : "8px";

    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: containerGap }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: containerGap }}>
          <Typography variant="body2" color="text.secondary">
            M
          </Typography>
          <TextField
            type="number"
            size="small"
            value={Math.floor(value / 60)}
            onChange={handleMinutesChange}
            slotProps={{
              input: {
                ref: ref,
                inputProps: {
                  min: 0,
                  max: 60,
                  style: { width: inputWidth, textAlign: "center" },
                },
              },
            }}
            sx={{ "& .MuiInputBase-input": { padding: inputPadding } }}
            required
          />
        </Box>
        <Typography variant="body2" color="text.secondary">
          :
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: containerGap }}>
          <Typography variant="body2" color="text.secondary">
            S
          </Typography>
          <TextField
            type="number"
            size="small"
            value={value % 60}
            onChange={handleSecondsChange}
            onKeyDown={handleSecondsKeyDown}
            slotProps={{
              input: {
                inputProps: {
                  min: 0,
                  max: 59,
                  style: { width: inputWidth, textAlign: "center" },
                },
              },
            }}
            sx={{ "& .MuiInputBase-input": { padding: inputPadding } }}
            required
          />
        </Box>
      </Box>
    );
  }
);

export default FormatTimestamp;
